import { IconList, IconListNumbers } from '@tabler/icons-react'

import { ListDisplayBlock as RenderListDisplayBlock } from '../../templateRenderer/DisplayBlocks/ListDisplayBlock'
import { ListDisplayBlock } from '../../types/blueprint'

import {
  BaseBlockConfig,
  Field,
  FORBIDDEN_IN_APP,
  ListField,
  SelectField,
  TypeOption,
} from './_BaseBlockConfig'

class Config extends BaseBlockConfig<ListDisplayBlock> {
  public override kind = 'display' as const
  public override type = 'list' as const

  public override blockTypeConfig: TypeOption = {
    kind: this.kind,
    value: this.type,
    label: 'List',
    icon: IconListNumbers,
    helpText: 'Show a number or bullet point list',
    forbiddenTemplateTypes: FORBIDDEN_IN_APP,
  }

  public override blockFieldsConfig: Field[] = [
    {
      name: 'listType',
      label: 'List type',
      field: SelectField,
      required: true,
      options: [
        {
          value: 'ordered',
          label: 'Ordered (numbered)',
          icon: IconListNumbers,
          default: true,
        },
        {
          value: 'unordered',
          label: 'Unordered',
          icon: IconList,
        },
      ],
    },
    {
      name: 'items',
      label: 'List items',
      field: ListField,
      required: true,
    },
  ]

  public override mapFormValueToBlock(
    block: ListDisplayBlock
  ): ListDisplayBlock {
    return block
  }

  public override renderBlock(block: ListDisplayBlock): React.ReactNode {
    return <RenderListDisplayBlock block={block} />
  }
}

export const ListDisplayBlockConfig = new Config()
